// extracted by css-extract-rspack-plugin
export default {"table":"PA5cz"};